import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "ccParticipants", "bccParticipants", "subject", "content" ]

  toggleCcBcc() {
    const ccInput  = this.ccParticipantsTarget.querySelector('input')
    const bccInput = this.bccParticipantsTarget.querySelector('input')

    if (!ccInput.value.trim()) this.ccParticipantsTarget.classList.toggle("tw-hidden")
    if (!bccInput.value.trim()) this.bccParticipantsTarget.classList.toggle("tw-hidden")
  }

  applyTemplate(event) {
    const option = event.target?.selectedOptions?.[0];
    if (!option) return;

    const subject = option.dataset.subject || "";
    const content = option.dataset.content || "";

    if (this.hasSubjectTarget) {
      this.subjectTarget.value = subject;
      this.subjectTarget.dispatchEvent(new Event("input", { bubbles: true }));
      this.subjectTarget.dispatchEvent(new Event("change", { bubbles: true }));

      if (this.subjectTarget.type !== "hidden") {
        window.mdFormHelper.handleMdFieldChange(this.subjectTarget, subject);
      }
    }
    if (!this.hasContentTarget) return;

    const textarea = this.contentTarget;
    const editor = window.tinymce?.get(textarea.id);

    if (editor) {
      editor.setContent(content);
      editor.save();
      return;
    }

    textarea.value = content;
  }
}
